export enum OverpaymentsEvents {
  SelfTestFailed = "LoanOverpayment_SelfTestFailed",
}
